// Imports
var ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notif-tile {
  border-bottom: 1px solid #dee2e6;
  padding-top: 15px;
  padding-bottom: 10px;
}

.notif-tile:hover {
  background-color: #ced4da;
  border-radius: 10px;
  cursor: pointer;
}

.desc {
  font-size: 0.82rem;
}`, ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
